import { render, staticRenderFns } from "./CommonFeaturesBlock.vue?vue&type=template&id=509bd3f1&scoped=true&"
import script from "./CommonFeaturesBlock.vue?vue&type=script&lang=ts&"
export * from "./CommonFeaturesBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFeaturesBlock.vue?vue&type=style&index=0&id=509bd3f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509bd3f1",
  null
  
)

export default component.exports